import { Button } from '@nextui-org/react'
import { MdBrowserUpdated } from 'react-icons/md'

const VersionCheckPage = () => {
  return (
    <main className='grid min-h-screen place-items-center px-6 py-24 sm:py-32 lg:px-8 bg-gray-200'>
      <div className='text-center bg-white p-20 rounded-lg shadow-lg border border-black'>
        <MdBrowserUpdated className='mx-auto h-12 w-12 text-warning' />
        <h1 className='mt-4 text-3xl font-bold tracking-tight text-gray-900 sm:text-5xl'>Nueva version disponible</h1>
        <p className='mt-6 text-base leading-7 text-gray-600'>Estas navegando en una version desactualizada.</p>
        <div className='mt-10 flex items-center justify-center gap-x-6'>
          <Button onClick={() => window.location.reload()} variant='shadow' className=' font-medium rounded-lg text-sm px-5 py-2.5 ' color='warning'>Actualizar</Button>
        </div>
      </div>
    </main>
  )
}

export default VersionCheckPage
